module.exports = __webpack_public_path__ + "media/sfx_correct.b86b28a6.mp3";